module.exports = __webpack_public_path__ + "img/unifisa-logo.122843fd.png";